import Orders from './orders';
import Menu from './menu';
import Home from './home';

export default {
  Orders,
  Menu,
  Home,
};
